import * as React from "react";
import PCILOGO from '../../assets/PCIimage/PCI-Compline1.png'
import "./footer.css";

const Footer = (props) => {
  const { StylingItem } = props;
  const main = {
    width: "100%",
    left: 0,
    right: 0,
    bottom: 0,
    flexShrink: 0,
    zIndex: "14",
  };
  return (
    <div>
      <div
        className="footerBar"
        style={{
          ...main,
          ["background"]: StylingItem && StylingItem.footerColor,
          ["fontFamily"]: StylingItem && StylingItem.font,
          ["color"]: StylingItem && StylingItem.footerFontColor,
        }}>
        <div className="inner">
          <div
            className="center"
            dangerouslySetInnerHTML={{
              __html: StylingItem && StylingItem.footerText,
            }}
          ></div>
          <div className="center">
            <a target="blank" href="https://permitsales.net/privacy.html">Privacy Policy</a>
          </div>
          <div className="sticky-badge">
            <a
              href="https://produs-ccs-assurancecard-service.sgsonline.net/assurancecard/be8e7fbc4499573f7b145a56278b3cf85bf003488c6d5bb2f611290b316e4afdee2fe267df20370c/assurancecard"
              target="blank">
              <img src={PCILOGO} alt="PCI Image" className="icon"/>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
